import React, { Component } from 'react'
import { connect } from 'react-redux'

// import styles
import './newsfeed.scss'

// Utils
import { translation } from '../../../utils/helpers'
import { isEqual } from 'lodash'

// Actions
import { updateNewsShowStatus } from '../../../actions/messages'

// Elements
import Check from '../../elements/check'
import Button from '../../elements/button'
// import PanelHeader from '../../elements/panelHeader'

class NewsFeed extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isOpened: false,
      reminder: false,
      nointerest: false
    }

    this.initItem = this.initItem.bind(this)
    this.toggleNews = this.toggleNews.bind(this)
    // this.handle = this.handle.bind(this)
    this.handleAction = this.handleAction.bind(this)
    this.onChange = this.onChange.bind(this)
  }

  componentDidMount () {
    // document.addEventListener('click', this.handle, true)
    this.initItem(this.props.item)
  }

  componentDidUpdate (next) {
    if (!isEqual(next.item, this.props.item)) {
      this.initItem(next.item || this.props.item)
    }
  }

  // componentWillUnmount () {
    // document.removeEventListener('click', this.handle, true)
  // }

  initItem (item) {
    if (item) {
      this.setState({
        isOpened: !item.IsRead,
        reminder: item.HasReminder
      })
    }
  }

  // handle (e) {
  //   const el = this.refs.newsContainer
  //   if (!el.contains(e.target) && this.state.isOpened) this.toggleNews({ target: false })
  // }

  toggleNews (open) {
    open = (typeof open.target !== 'undefined') ? !this.state.isOpened : open
    this.setState({
      isOpened: open
    }, () => {
      if (open === false && !this.props.item.IsRead) {
        this.handleAction(true)
      }
    })
  }

  handleAction (isRead = false) {
    let data = {
      MessageId: this.props.item.Id,
      RemindMe: this.state.reminder,
      IsDismissed: this.state.nointerest
    }

    if (isRead) {
      data = {
        MessageId: this.props.item.Id,
        IsRead: true
      }
    }

    this.props.updateNewsShowStatus(data).then(res => {
      this.setState({
        isOpened: false
      })

      if (this.state.nointerest) {
        this.props.refreshItem()
      }
    })
  }

  onChange (e) {
    let name = e.target.name
    let value = e.target.checked

    this.setState({
      [name]: value
    }, this.handleAction)
  }

  renderDownloadButton (msgDocument) {
    if (msgDocument === null || !msgDocument.FileURL) return null

    const src = msgDocument.FileURL
    const label = /.*.pdf$/.test(src.toLowerCase()) ? '2238' : '15294'
    // return (
    //   <div className='getPDF'>
    //     <a href={src} target='_BLANK'>{translation(label)}</a>
    //   </div>
    // )
    return (
      <Button spacing={2} labelText={translation(label)} onClick={() => window.open(src, '_blank')} />
    )
  }

  renderIllustration (msgIllustration) {
    if (msgIllustration === null || !msgIllustration.FileURL) return null

    return (
      <div className='news__content-graphics'>
        <img src={msgIllustration.FileURL} />
      </div>
    )
  }

  renderNewsMenu (item) {
    return (
      <div className='news__dropdown__menu'>
        <div className='news__content'>
          <div className='title'>{item.Subtitle}</div>
          <div>{item.Body}</div>
          {this.renderDownloadButton(item.MessageDocument)}
          {this.renderIllustration(item.MessageIllustration)}
          <div className='news__content-checkboxgroup'>
            <Check spacing={2} labelText={translation('15278')} id='reminder' name='reminder' onChange={this.onChange} checked={this.state.reminder} />
            <Check spacing={2} labelText={translation('15279')} id='nointerest' name='nointerest' onChange={this.onChange} checked={this.state.nointerest} />
          </div>
        </div>
        <div className='news__footer'>
          <div className='title'>{translation('15280')}</div>
          <img src='/images/icons/support-100x100px.png' />
          <div className='contact__info'>
            <span>+45 70 70 72 85</span>
            <span>info@apromas.com</span>
            <span>sales@apromas.com</span>
          </div>
        </div>
      </div>
    )
  }

  render () {
    console.log('here ', this.props.item)
    if (!this.props.item) return null
    const { item } = this.props
    console.log('NEWSFEED - this.props.item ', this.props.item)

    let triggerClass = 'fa fa-chevron-down'
    if (this.state.isOpened) {
      triggerClass = 'fa fa-close'
    }
    return (
      <div className='news__menu' ref='newsContainer'>
        {this.state.isOpened && <div className='news__menu__backdrop' onClick={() => this.toggleNews({ target: false })} />}
        <div className='newsBox' onClick={this.toggleNews}>
          <img src='/images/svgs/Cirkle_info-white.svg' />
          <span className='news_title'>
            <span>{item.Title}</span>
            <span>{item.Subtitle}</span>
          </span>
          <i className={triggerClass} />
        </div>
        {this.state.isOpened && this.renderNewsMenu(item)}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  updateNewsShowStatus
})(NewsFeed)



// WEBPACK FOOTER //
// ./src/app/shared/components/NewsFeed/index.js